import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';

import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';

import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';

import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';

import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

import type { ChecklistItemCompletedFromTraits } from '../types';

import { defaultMessages } from '../messages';

import { type JSX } from 'react/jsx-runtime';

type OptionsDropdownMenuProps = {
	completedItems: Partial<ChecklistItemCompletedFromTraits>;
	onDismiss: () => void;
};

export const OptionsDropdownMenu = ({
	completedItems,
	onDismiss,
}: OptionsDropdownMenuProps): JSX.Element => {
	const { formatMessage } = useIntl();
	const { onDeclined } = usePostOfficeUserInteractions();

	const handleDismiss = useCallback(() => {
		onDismiss();
		void onDeclined({
			interactionIdentifier: 'checklist-dismiss-button',
			additionalMetadata: {
				numberOfCardsCompleted: Object.values(completedItems).length,
				completedItems: Object.keys(completedItems).join(','),
				completedAllItems: Object.values(completedItems).length === 5,
			},
		});
	}, [completedItems, onDismiss, onDeclined]);

	return (
		<DropdownMenu<HTMLButtonElement>
			trigger={({ triggerRef, ...props }) => (
				<IconButton
					{...props}
					ref={triggerRef}
					icon={ShowMoreHorizontalIcon}
					label={formatMessage(defaultMessages.optionsMenuTitle)}
					appearance="subtle"
					spacing="compact"
				/>
			)}
			shouldRenderToParent
		>
			<DropdownItemGroup>
				<DropdownItem onClick={handleDismiss}>
					{formatMessage(defaultMessages.dismissButtonLabel)}
				</DropdownItem>
			</DropdownItemGroup>
		</DropdownMenu>
	);
};
